import { render, staticRenderFns } from "./BelyashiEggText.vue?vue&type=template&id=5a696dfd&scoped=true"
import script from "./BelyashiEggText.vue?vue&type=script&lang=js"
export * from "./BelyashiEggText.vue?vue&type=script&lang=js"
import style0 from "./BelyashiEggText.vue?vue&type=style&index=0&id=5a696dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a696dfd",
  null
  
)

export default component.exports